<template>

  <div id="app">
    <!-- && $route.name !== 'account'  && $route.name !== 'registration' -->
    <div v-if="$route.name !== 'login' ">
    <Sidebar/>
    <div v-if="$route.name == 'home'" >
    <!-- <Profile/> -->
    </div>
    <div class="app-content" :class="{ 'profile': $route.name == 'home' }">
      <AppHeader/>
      <router-view ></router-view>
    <AppFooter />
    </div>
      
    </div>
    <div v-else>
      <router-view ></router-view>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/partials/Header.vue'
import AppFooter from '@/components/partials/Footer.vue'
import Sidebar from './components/partials/Sidebar.vue'
// import Profile from './components/partials/Profile.vue'0

export default {
  name: 'app',
  components: {
    AppHeader,
    AppFooter,
    Sidebar,
  }

}
</script>
<style>
/* @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Domine:wght@400;700&display=swap'); */
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

body {
  overflow: hidden !important;
  background: var(--third) !important;
}
/* font-family: 'Source Sans Pro', sans-serif;
font-family: 'Trocchi', serif; */
#app {
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  overflow: hidden;
}
h1, h2{
 font-family: 'Montserrat', sans-serif;
}
h3, h4{
  font-family: 'Montserrat', sans-serif;
}
.app-content{
  height: 100vh;
  position: relative;
  z-index: 1;
  margin-left: 80px !important;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.app-content > * {
  flex-shrink: 0;
}

.app-content > router-view {
  flex: 1;
  overflow-y: auto;
}

/* .app-content.profile{
  margin-right: 280px;
} */

input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

:focus {
  outline: -webkit-focus-ring-color auto 0px;
}


::-webkit-scrollbar {
	-webkit-appearance: none;
}

::-webkit-scrollbar:vertical {
	width: 0.3rem;
}

::-webkit-scrollbar:horizontal {
	height: 0.3rem;
}

::-webkit-scrollbar-track {
  background: #eeeeee;
}

::-webkit-scrollbar-thumb {
  background: var(--first-op);
}
a{
  color: #2c3e50 !important ;
}
a:hover, a:hover * {
  text-decoration: none !important;
  color: inherit;
}
.btn.focus, .btn:focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgb(80 80 80 / 25%);
}
@media (max-width: 1496px) {
  /* .app-content.profile{
  margin-right: auto;
} */
}

</style>